import React from 'react'
import styled from 'styled-components'

const Breadcrumbs = ({ children }) => {
  return <Wrapper className="breadcrumbs">{children}</Wrapper>
}

const Wrapper = styled.ul`
  --font-size-breadcrumbs: var(--font-size-1);
  --font-lineheight-breadcrumbs: 100%;
  --font-weight-breadcrumbs: var(--font-weight-7);

  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
  /* font-family: var(--font-mono); */
  font-size: var(--font-size-breadcrumbs);
  line-height: var(--font-lineheight-breadcrumbs);
  font-weight: var(--font-weight-breadcrumbs);
  color: var(--color-text2-inverted);
`

export default Breadcrumbs
